import { formatEventTime } from "../utils/dateTimes";
import { MealFragment, MealType } from "../types";

export const formatMeal = (meal: Pick<MealFragment, "start" | "end" | "name">) => {
  return `${meal.name} (${formatEventTime(meal)})`;
};

export const orderedMealTypes: readonly MealType[] = ["breakfast", "lunch", "dinner", "snack"];
